import { styled, Box, List } from "@mui/material";

export const SelectedSummaryRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "2px 10px",
  zIndex: 9,
  display: "flex",
  flexDirection: "column",
  justifyContent: "stretch",
  alignItems: "flex-start",
  [theme.breakpoints.up("lg")]: { padding: "5px 10px" },
  [theme.breakpoints.up("xl")]: { padding: "5px 20px" },
}));

export const SelectedSummaryHeader = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "none",
  marginBottom: 20,
  [theme.breakpoints.up("lg")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export const SelectedSummaryContent = styled(List)(({ theme }) => ({
  width: "100%",
  zIndex: 1,
  borderRadius: theme?.borderRadius?.default,
  overflowY: "auto",
  background: `rgba(${theme.palette.companyColors.neutralRGB}, 0.65)`,
  borderRight: "2px solid #fff",
  display: "none",
  "&::-webkit-scrollbar-track": {
    marginTop: 2,
    marginBottom: 2,
  },
  [theme.breakpoints.up("lg")]: {
    display: "block",
    maxHeight: "7.5dvh",
  },
  [theme.breakpoints.up("xl")]: {
    maxHeight: "13.5dvh",
  },
  "@media screen and (min-width:1535px)": {
    maxHeight: "8dvh",
  },
  "@media screen and (min-width:1650px)": {
    maxHeight: "7.5dvh",
  },
  "@media screen and (min-width:1815px)": {
    maxHeight: "8.5dvh",
  },
  "@media screen and (min-width:2000px)": {
    maxHeight: "9dvh",
  },
  "@media screen and (min-width:2300px)": {
    maxHeight: "10dvh",
  },
}));

export const SelectedSummaryFooter = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 0,
  [theme.breakpoints.up("lg")]: { marginTop: 15 },
}));
